/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScoreboardEventBreakdownListDates = {
    type: 'array',
    contains: {
        type: 'ScoreboardEventBreakdownDates',
    },
};